import React, { useEffect, useState } from 'react';
import Notice from '../components/Notice';
import { confirmDialog } from '../components/ConfirmDialog';

export default function CardManagement({ user }) {
  const [tab, setTab] = useState('mine');
  const [myCards, setMyCards]     = useState([]);
  const [readers, setReaders]     = useState([]);
  const [unregistered, setUnreg]  = useState([]);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  // 自分のカード追加
  const [cardId, setCardId]   = useState('');
  const [cardLabel, setLabel] = useState('');

  // リーダー追加
  const [readerName, setRName]     = useState('');
  const [readerLoc,  setRLoc]      = useState('');

  const auth = () => ({
    Authorization: 'Bearer ' + localStorage.getItem('token'),
    'Content-Type': 'application/json'
  });

  const loadMyCards = async () => {
    try {
      const r = await fetch('/api/card/user-cards', { headers: auth() });
      const d = await r.json();
      setMyCards(d.cards || d.data || []);
    } catch (e) { setErr(e.message); }
  };
  const loadReaders = async () => {
    try {
      const r = await fetch('/api/card/readers', { headers: auth() });
      const d = await r.json();
      setReaders(d.readers || d.data || []);
    } catch (e) { setErr(e.message); }
  };
  const loadUnreg = async () => {
    try {
      const r = await fetch('/api/card/admin/unregistered', { headers: auth() });
      const d = await r.json();
      setUnreg(d.students || d.data || []);
    } catch (e) { setErr(e.message); }
  };

  useEffect(() => {
    if (tab === 'mine')         loadMyCards();
    if (tab === 'readers')      loadReaders();
    if (tab === 'unregistered') loadUnreg();
    // eslint-disable-next-line
  }, [tab]);

  const addMyCard = async (e) => {
    e.preventDefault();
    try {
      const r = await fetch('/api/card/user-cards', {
        method: 'POST', headers: auth(),
        body: JSON.stringify({ card_id: cardId, label: cardLabel })
      });
      const d = await r.json();
      if (!r.ok && !d.success) throw new Error(d.message || '登録失敗');
      setMsg('カードを登録しました'); setCardId(''); setLabel('');
      loadMyCards();
    } catch (e) { setErr(e.message); }
  };

  const delMyCard = async (id) => {
    if (!(await confirmDialog('このカード登録を削除しますか？'))) return;
    try {
      await fetch('/api/card/user-cards/' + id, { method: 'DELETE', headers: auth() });
      loadMyCards();
    } catch (e) { setErr(e.message); }
  };

  const addReader = async (e) => {
    e.preventDefault();
    try {
      const r = await fetch('/api/card/readers', {
        method: 'POST', headers: auth(),
        body: JSON.stringify({ name: readerName, location: readerLoc })
      });
      const d = await r.json();
      if (!r.ok && !d.success) throw new Error(d.message || '登録失敗');
      setMsg('リーダーを登録しました'); setRName(''); setRLoc('');
      loadReaders();
    } catch (e) { setErr(e.message); }
  };

  const delReader = async (id) => {
    if (!(await confirmDialog('このリーダーを削除しますか？'))) return;
    try {
      await fetch('/api/card/readers/' + id, { method: 'DELETE', headers: auth() });
      loadReaders();
    } catch (e) { setErr(e.message); }
  };

  const isStaff = user?.role === 'teacher' || user?.role === 'developer' || user?.role === 'academic_staff';

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>ICカード管理</h1>
        <p>Felicaなどのカード登録、リーダーの管理ができます。</p>
      </div>

      <div className="tab-bar">
        <button className={'tab-btn'+(tab==='mine'?' active':'')} onClick={()=>setTab('mine')}>自分のカード</button>
        {isStaff && <button className={'tab-btn'+(tab==='readers'?' active':'')}      onClick={()=>setTab('readers')}>リーダー</button>}
        {isStaff && <button className={'tab-btn'+(tab==='unregistered'?' active':'')} onClick={()=>setTab('unregistered')}>未登録の学生</button>}
      </div>

      <Notice kind="error">{err}</Notice>
      <Notice kind="success" toast>{msg}</Notice>

      {/* 自分のカード */}
      {tab === 'mine' && (
        <>
          <div className="card">
            <div className="card-header"><h2>カードを登録</h2></div>
            <form onSubmit={addMyCard}>
              <div className="form-row">
                <label>カードID *</label>
                <input value={cardId} onChange={e=>setCardId(e.target.value)} required placeholder="Felica IDmなど"/>
              </div>
              <div className="form-row">
                <label>ラベル</label>
                <input value={cardLabel} onChange={e=>setLabel(e.target.value)} placeholder="例: 学生証"/>
              </div>
              <button className="btn-primary" type="submit">登録</button>
            </form>
          </div>

          <div className="card">
            <div className="card-header"><h2>登録済みカード</h2></div>
            {myCards.length === 0 ? <p style={{color:'#888'}}>カードが登録されていません</p> : (
              <table className="data-table">
                <thead><tr><th>カードID</th><th>ラベル</th><th>登録日</th><th></th></tr></thead>
                <tbody>{myCards.map(c => (
                  <tr key={c.id}>
                    <td style={{fontFamily:'monospace',fontSize:'0.85rem'}}>{c.card_id}</td>
                    <td>{c.label || '-'}</td>
                    <td>{c.created_at?.split('T')[0]}</td>
                    <td><button className="btn-danger" onClick={()=>delMyCard(c.id)}>削除</button></td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>
        </>
      )}

      {/* リーダー（教員以上） */}
      {tab === 'readers' && isStaff && (
        <>
          <div className="card">
            <div className="card-header"><h2>リーダーを登録</h2></div>
            <form onSubmit={addReader}>
              <div className="form-row">
                <label>名前 *</label>
                <input value={readerName} onChange={e=>setRName(e.target.value)} required placeholder="例: 第1講義室リーダー"/>
              </div>
              <div className="form-row">
                <label>場所</label>
                <input value={readerLoc} onChange={e=>setRLoc(e.target.value)} placeholder="例: A棟101"/>
              </div>
              <button className="btn-primary" type="submit">登録</button>
            </form>
          </div>

          <div className="card">
            <div className="card-header"><h2>リーダー一覧</h2></div>
            {readers.length === 0 ? <p style={{color:'#888'}}>リーダーがありません</p> : (
              <table className="data-table">
                <thead><tr><th>名前</th><th>場所</th><th>状態</th><th></th></tr></thead>
                <tbody>{readers.map(r => (
                  <tr key={r.id}>
                    <td><strong>{r.name}</strong></td>
                    <td>{r.location || '-'}</td>
                    <td>{r.active ? '有効' : '無効'}</td>
                    <td><button className="btn-danger" onClick={()=>delReader(r.id)}>削除</button></td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>
        </>
      )}

      {/* 未登録学生 */}
      {tab === 'unregistered' && isStaff && (
        <div className="card">
          <div className="card-header"><h2>カード未登録の学生 ({unregistered.length})</h2></div>
          {unregistered.length === 0 ? <p style={{color:'#888'}}>全学生が登録済みです</p> : (
            <table className="data-table">
              <thead><tr><th>学籍番号</th><th>氏名</th><th>メール</th></tr></thead>
              <tbody>{unregistered.map(s => (
                <tr key={s.id || s.student_id}>
                  <td>{s.student_id}</td>
                  <td>{s.name}</td>
                  <td style={{fontSize:'0.85rem',color:'#666'}}>{s.email || '-'}</td>
                </tr>
              ))}</tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
